import { produce } from 'immer';
import { types } from './actions.js';

var initialState = {
  isFetchingMarkdown: null,
  markdownFiles: {},
  isFetchingJson: null,
  jsonFiles: {}
};
var reducer = function reducer(state, _ref) {
  if (state === void 0) {
    state = initialState;
  }
  var type = _ref.type,
    payload = _ref.payload,
    error = _ref.error;
  return produce(state, function (draftState) {
    switch (type) {
      case types.FETCH_MARKDOWN:
        draftState.isFetchingMarkdown = true;
        break;
      case types.FETCH_MARKDOWN_SUCCESS:
        draftState.isFetchingMarkdown = false;
        draftState.markdownFiles[payload.url] = payload;
        break;
      case types.FETCH_MARKDOWN_ERROR:
        draftState.isFetchingMarkdown = false;
        draftState.markdownFiles[payload.url] = {
          error: error
        };
        break;
      case types.FETCH_JSON:
        draftState.isFetchingJson = true;
        break;
      case types.FETCH_JSON_SUCCESS:
        draftState.isFetchingJson = false;
        draftState.jsonFiles[payload.url] = payload.json;
        break;
      case types.FETCH_JSON_ERROR:
        draftState.isFetchingJson = false;
        draftState.jsonFiles[payload.url] = {
          error: error
        };
        break;
      // do nothing
    }

    return undefined;
  });
};
var reducer$1 = reducer;

export { reducer$1 as default, initialState };
//# sourceMappingURL=reducer.js.map
